
import angular from "angular";
import BinaryTreeFactory from "./BinaryTreeFactory";

export default angular.module("trackerbase-apps.services.binary-tree",[])
    .service("BinaryTreeFactory", BinaryTreeFactory) // injector info in $inject
    .name;




//////////////////
// WEBPACK FOOTER
// ./src/services/binary-tree/index.js
// module id = br3p
// module chunks = 1